<template>
  <div id="outerFrame" :style="getMainStyle">
    <Header />

    <div ref="frame" class="frame">
        <div
          :style="{
            height: getScreenHeight + 'px',
            position: 'relative',
            top: '0px',
            zIndex: '1',
          }"
          v-if="this.selectedProjectIndex == -1"
        >
          <transition-group name="fade" appear>
            
            <div v-for="(_project, index) in this.getConformedProjects" :key="index">
              
              <div class="projectPreviewFrame" v-if="isVisible(index, _project)" >

                <ProjectContent
                  :pWidth="getProjectWidth"
                  :pIndex="index"
                  :pHeight="getProjectHeight"
                  :pProject="_project"
                  :pSelectedProjectIndex="selectedProjectIndex"
                  :pIsSelected="false"
                />
              </div>
            </div>
          </transition-group>

          <div :style="{
          height: '95px',
          position: 'relative'
        }"></div>
        </div>

        <div
          :style="{
            height: getScreenHeight + 'px',
            position: 'relative',
            top: '0px',
            zIndex: '1'
          }"
          v-else
        >
          <div class="projectPreviewFrame">

            <div class="projectBack" @click="goHome('home')"><img src="/images/arrows_left.png"/></div>

            <ProjectContent
              :pWidth="getProjectWidth"
              :pIndex="this.selectedProjectIndex"
              :pHeight="getProjectHeight"
              :pProject="this.getConformedProjects[this.selectedProjectIndex]"
              :pSelectedProjectIndex="selectedProjectIndex"
              :pIsSelected="true"
            />

          </div>
        </div>
    </div>

    

    <Footer class="footerClass" :pScrollLoc="1" />

    
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import ProjectContent from "@/components/ProjectContent.vue";
import StrapiService from "@/services/StrapiService.js";

import gsap from "gsap";
import { ScrollToPlugin } from "gsap/all";
import { EventBus } from "@/event-bus.js";

gsap.registerPlugin(ScrollToPlugin);

export default {
  name: "App",
  components: {
    Header,
    Footer,
    ProjectContent,
  },
  props: ['projectName'],
  methods: {

    projectInRange(_index) {

      if (_index > this.focusedIndex-1 && _index < this.focusedIndex+5) {
        return true
      } else {
        return false
      }
    },
    goHome(_home) {

        console.log(_home);
        this.selectedProjectIndex = -1;
        this.categoryFilterIndex = -1;

        EventBus.$emit("set-nav-filter", this.categoryFilterIndex);
        this.backToTop();
    },
    getProjectFromName(_name) {

      for (var i=0; i<this.arrProjects.length; i++) {

        var _str = this.arrProjects[i].title.replace(/\s+/g, '-').toLowerCase();
        console.log(_str + " | " + _name)
        if (_name == _str) {
          return i
        }
      }
      return -1
    },
    /*
    animateHeaderSize(_on) {

      console.log(_on)

      if (_on != this.headerOpen) {
        this.headerOpen = _on;
        gsap.to(".frame", {
          duration: 0.4,
          paddingTop: _on ? 71 : 0,
          //paddingTop: _on ? 120 : 49,
        });
      }
    },*/
    getMainCategory: function (_p) {
      var _cat = "";
      if (_p.madsci_primary_category) {
        _cat = _p.madsci_primary_category.title;
      }
      console.log(">>" + _cat);
      return _cat;
    },
    isVisible: function (_index, _project) {
      var _visible = true;

      if  (!this.isPrivate && _project.isPrivate) {
        _visible = false
      }

      //If we have selected an event
      if (
        this.selectedProjectIndex != _index &&
        this.selectedProjectIndex != -1
      ) {
        _visible = false;
      }

      //Check category Filters
      if (
        (this.categoryFilterIndex != -1 &&
          this.arrCategoryFilterNames[this.categoryFilterIndex] !=
            this.getMainCategory(_project)) ||
        (this.categoryFilterIndex == -1 && _project.isNotFeatured == true)
      ) {
        _visible = false;
      }

      return _visible;
    },
    backToTop: function () {
      console.log("FROM TOP: " + window.scrollY);
      console.log("OFFSET TOP: " + window.offsetY);

      //window.y = window.scrollY;
      gsap.to(".frame", {
        duration: 0.6,
        scrollTo: 0,
        ease: "expo.inOut",
      });

      this.toggleFooter(false);
    },
    toggleFooter(_on) {
      var _loc = -50;
      if (_on) {
        _loc = -12;
      }

      gsap.to(".footerClass", {
        duration: 0.35,
        bottom: _loc,
      });
    },
    handleResize() {
      this.count++;
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;

    },
    handleScroll() {

      var _st = this.$refs.frame.scrollTop
      this.focusedIndex = (_st / this.getProjectHeight).toFixed(0)

      if (this.$refs.frame) {
        if (_st > 0) {
          this.toggleFooter(true);

          if (!this.initHeader) {

            //this.initHeader = true;
            //this.animateHeaderSize(false);
            
            EventBus.$emit("set-nav", false);
          }
          this.scrollCount = 0
        } else {
          this.toggleFooter(false);

          this.scrollCount++
          if (this.scrollCount > 10) {
            this.scrollCount = 0
            EventBus.$emit("set-nav", true);
          }
        }
      }
    },
  },
  computed: {

    getProjectFrame() {

      return {
        position: 'relative',
        border: 'solid 1px #ff0000',
        height: this.getProjectHeight + 'px',
        width: this.getProjectWidth + 'px'
      }
    },
    getMainStyle() {
      return {
        width: "100%",
        height: "100%",
        overflow: "hidden",
      };
    },

    getFrameStyle: function () {
      return { 
        height: this.windowHeight + "px",
        position: "relative",
        top: "10px",
        left: "0px"     
      };
    },
    getConformedProjects: function () {
      return this.arrProjects;
    },
    getScreenHeight: function () {
      var _val = window.innerHeight;
      return _val;
    },
    getProjectHeight: function () {

      return this.windowWidth * .21
      //return window.innerWidth * 0.21;
    },
    getProjectWidth: function () {

      return .7 * this.windowWidth
      //return 0.7 * window.innerWidth;
    },
  },
  mounted() {

      StrapiService.getProjects().then((response) => {

        this.handleResize()

        this.arrProjects = response.data;

        console.log(this.arrProjects)

        //If event passed in
        if (this.$route.name == 'madsci-project') {
          this.selectedProjectIndex = this.getProjectFromName(this.projectName)
          console.log("*** project : " + this.projectName + " " + this.selectedProjectIndex)
        }
      });

  },
  created() {
    this.windowHeight = window.innerHeight;

      EventBus.$on("go-home", (_home) => {

        this.goHome(_home)
      }),
      EventBus.$on("back-to-top", (_out) => {
        console.log(_out);
        this.backToTop();
      }),
      EventBus.$on("set-filter", (_f) => {
        this.selectedProjectIndex = -1;
        this.categoryFilterIndex = _f;
      }),
      EventBus.$on("select-project", (_i) => {
        if (this.selectedProjectIndex == _i) {
          this.selectedProjectIndex = -1;
        } else {
          this.selectedProjectIndex = _i;
        }
        this.backToTop();
      }),

    //Mouse wheel
    window.addEventListener("wheel", this.handleScroll);
    window.addEventListener("resize", this.handleResize);


    if (this.$route.name == 'madsci-private') {
      this.isPrivate = true
    }

  },
  data() {
    return {
      scrollCount: 0,
      focusedIndex: 0,
      isPrivate: false,

      initHeader: false,
      headerOpen: true,

      windowWidth:0,
      windowHeight: 0,

      count: 0,
      arrProjects: [],
      selectedProjectIndex: -1,
      categoryFilterIndex: -1,
      nameFilter: "",
      arrCategoryFilterNames: [
        "Projects & Events",
        "Agency Work",
        "Research & Experiments",
      ],
    };
  },
};
</script>

<style>

html {
  -webkit-text-size-adjust: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */
  -khtml-user-select: none; /* Konqueror */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently*/
}

.embed-container {
      position: relative;
      padding-bottom: 56.25%;

      height: 0;
      overflow: hidden;
      max-width: 100%;
      height: auto;
      border: solid 1px #ffff00;
    }

    .embed-container iframe,
    .embed-container object,
    .embed-container embed {
      position: absolute;
      top: 13%;
      width: 100%;
      height: 75%;
    }
     
h1 {
  line-height: 1.2;
}

::-webkit-scrollbar {
  display: none;
}

.projectBack_frame {

  position: absolute;
  top: 20px;
  left: 20px;
}

.projectBack {
  position: sticky;
  left: 0px;
  top: 20px;
  font-size: 30px;
  font-weight: 600;
  width: 40px;
  height: 30px;
  color: #414141;
  z-index: 100;
}

.fade-enter {
  opacity: 0;
}
.fade-enter-active {
  transition: all 0.5s ease-out;
}

.fade-leave-active {
  transition: all 0.5s ease-in;
}
.fade-leave-to {
  opacity: 0;
}

.list-complete-move {
  transition: transform 0.5s ease-in;
}
.list-complete-item {
  transition: all 1s;
}
.list-complete-enter, .list-complete-leave-to
/* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(30px);
}
.list-complete-leave-active {
  position: absolute;
}

#outerFrame 
{ 
  font-family: "Oswald", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  height: 100%;
  position: relative;
  left: 0px;
  padding: 6px;
}

.frame {
  overflow-y: scroll;
  overflow-x: hidden;

  text-align: center;
  color: #414141;

  margin: 0 auto;
  top: 0px;

  position: relative;
  padding-bottom: 0px;

}

body {
  font-family: "Oswald", sans-serif;

  margin: 0px;
  padding: 0px;


  font-size: 16px;
  line-height: 1.1;

  overflow: hidden;
}

a {
  color: #414141;
  font-weight: 700;
  background-color: transparent;
  text-decoration: none;
  cursor: pointer;

  font-size: 12px;
  line-height: 1.1;
}

a:hover {
  opacity: 1;
  text-decoration: underline;
  cursor: pointer;
}

.footerClass {
  position: absolute;
  bottom: -50px;
  position: fixed;
}

.projectPreviewFrame {
  padding-top: 6px;
  position: relative;
}
</style>
